"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _messages = require("../../utils/messages");

var _imageuploader = _interopRequireDefault(require("./imageuploader"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}
/* ========== ~~~~~~~~~~ BUTTON: PARENT ~~~~~~~~~~ ========== */
// map state


var mapStateToProps = function mapStateToProps(_ref) {
  _objectDestructuringEmpty(_ref);

  return {};
}; // map actions


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    sendErrorMessage: function sendErrorMessage(message) {
      return dispatch((0, _messages.sendErrorMessage)(message));
    }
  };
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_imageuploader.default);

exports.default = _default;